module.exports = __webpack_public_path__ + "img/avg_ticket_progression.a3e2c70f.svg";